import { NavigationItem } from '../types/navigation';
import { colors } from '../styles/theme';

export const services: NavigationItem[] = [
  {
    name: 'Canva Pro',
    path: '/services/canva-pro',
    color: colors.secondary,
    iconName: 'Palette'
  },
  {
    name: 'Web Hosting',
    path: '/services/hebergement',
    color: colors.tertiary,
    iconName: 'Globe'
  },
  {
    name: 'Forum',
    path: '/services/ressources',
    color: colors.accent1,
    iconName: 'BookOpen'
  },
  {
    name: 'Virtual Private Server',
    path: '/services/vps',
    color: colors.accent2,
    iconName: 'Code'
  },
  {
    name: 'Office 365',
    path: '/services/logiciels',
    color: colors.accent3,
    iconName: 'Laptop'
  },
  {
    name: 'Email',
    path: '/services/mail',
    color: colors.primary,
    iconName: 'Mails'
  }
];